export enum CountryCode {
	AU = "AU",
	NZ = "NZ",
}